import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { ApiService } from '@app/core/services/api.service';
import { PreLoginContent } from '@app/core/models';

@Injectable({ providedIn: 'root' })
export class PreLoginContentService {
  /**
   * constructor
   * @param {ApiService} apiService
   * @param {HttpClient} http
   */
  constructor(private apiService: ApiService, private http: HttpClient) {}

  /**
   * getContent
   * @returns {Observable<PreLoginContent>}
   */
  getContent(): Observable<PreLoginContent> {
    return this.apiService.get('/content');
  }
}
